import { css } from '@emotion/react';
import { White, Gray } from '@constants/color';

export const container = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
});

export const textContainer = css({
  marginBottom: 60,
  textAlign: 'center'
});

export const bottomContainer = css({
  width: '320px'
});

export const title = css({
  fontSize: 48,
  fontWeight: 700,
  lineHeight: '62.4px',
  color: White.White10,
  paddingBottom: 40
});

export const instruction = css({
  color: Gray.Gray60,
  fontWeight: 500,
  fontSize: 24,
  lineHeight: '180%'
});
